import { toTimeValue } from "./dateTime";

export function toTimestampValue(value) {
  if (value === null || value === undefined || value === "") return 0;

  if (typeof value === "number" && Number.isFinite(value)) {
    return value;
  }

  return toTimeValue(value);
}

export function formatRelativeTimeShort(value, { emptyValue = "-" } = {}) {
  if (value === null || value === undefined || value === "") return emptyValue;

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return emptyValue;

    if (/^(now|just now|today)$/i.test(trimmed)) return "0m ago";
    if (/^yesterday$/i.test(trimmed)) return "1d ago";

    const longRelativeMatch = trimmed.match(
      /^(\d+)\s*(seconds?|secs?|minutes?|mins?|hours?|hrs?|days?|weeks?|months?|years?)\s+ago$/i
    );
    if (longRelativeMatch) {
      const unit = longRelativeMatch[2].toLowerCase();
      const suffix = unit.startsWith("second") || unit.startsWith("sec")
        ? "m"
        : unit.startsWith("minute") || unit.startsWith("min")
        ? "m"
        : unit.startsWith("hour") || unit.startsWith("hr")
        ? "h"
        : unit.startsWith("day")
        ? "d"
        : unit.startsWith("week")
        ? "w"
        : unit.startsWith("month")
        ? "mo"
        : "y";
      return `${longRelativeMatch[1]}${suffix} ago`;
    }
    if (/^\d+\s*(mo|[smhdwy])\s+ago$/i.test(trimmed)) return trimmed.toLowerCase();

    const shortLabelMatch = trimmed.match(/^(\d+)\s*(mo|[smhdwy])$/i);
    if (shortLabelMatch) {
      return `${shortLabelMatch[1]}${shortLabelMatch[2].toLowerCase()} ago`;
    }
  }

  const timestamp = toTimestampValue(value);
  if (!timestamp) return String(value);

  const diffMs = Date.now() - timestamp;
  if (!Number.isFinite(diffMs) || diffMs <= 0) return "0m ago";

  const seconds = Math.floor(diffMs / 1000);
  if (seconds < 60) return "0m ago";

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;

  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d ago`;

  const weeks = Math.floor(days / 7);
  if (weeks < 5) return `${weeks}w ago`;

  const months = Math.floor(days / 30);
  if (months < 12) return `${months}mo ago`;

  const years = Math.floor(days / 365);
  return `${years}y ago`;
}
